import * as React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import AppointmentInfo from "../../AppointmentInfo";
import * as Tools from "../../../../helpers/Tools";
import { translateText } from '../../../../helpers/data';
import { logUI } from '../../../../api/andyliticsApi';
import NoProxy from '../../../common/NoProxy';
import SelectPatient from '../../../common/SelectPatient';
import OurStepManager from "../../../common/OurStepManager";
import * as d from "../../../../reducers/domainReducer";
import PatientInfo from "../../PatientInfo";
import ServiceVerifyNSchedule from '../../ServiceVerifyNSchedule';
import * as types from "../../../../constants/actionTypes";
import * as queryString from 'query-string';
import OpenScheduleConfirmationSuccess from "../../OpenScheduleConfirmationSuccess";
import ConfirmationModal from "../../../common/ConfirmationModal";
import Spinner from "../../../common/spinner";
import * as msgs from "../../../../constants/textConstants";
import { gaCheckout } from "../../../../api/gaLoging";
import { withTranslation } from 'react-i18next';

const DATE_FORMAT = Tools.getDateFormats();

const PROVIDER_TYPE_EPIC_ID = "EpicID";
const PROVIDER_TYPE_NPI = "NPI";
const OPEN_SCHEDULE_TYPE = "OpenSchedule";
const PROVIDER_NPI = "ProviderNPI";
const PROV_ID = "PROVID";
const enableFluVaccineSchedulingWorkflow = window.serverData &&  window.serverData.data && window.serverData.data.enableFluVaccineSchedulingWorkflow;
class ScheduleFlu extends React.Component {
    constructor(props) {
        super(props);
        this.refOurStepManager = React.createRef();

        const searchModel = this.getSearchModel();
        let {
            providerId,
            scheduleType,
            visitTypeId,
            departmentId,      // optional selected department id
            selectedDate,     // optional YYYY-MM-DD
            selectedTime,    // optional HH:MM:SS ... dunno why they want the seconds, but they do
            altStart,       // alternative date-range starting date
            correlationId,
            gacookie,
            isFromDotCOM
        } = searchModel;
        const patient = this.props.currentUser ? this.props.currentUser : undefined;
        const email = this.props.patientEmail ? this.props.patientEmail : "";
        const patientId = "";
        const loginId = "";
        const userName = "";
        let dt = new Date();
        if (altStart) {
            dt = Tools.toJSDate(`${altStart} 00:00:00`, DATE_FORMAT);
        }
        else if (selectedDate) {
            dt = Tools.toJSDate(`${selectedDate} 00:00:00`, DATE_FORMAT);
        }
        else {
            dt.setDate(1);
        }
        let dtEnd = Tools.getEndOfMonth(dt.getFullYear(), dt.getMonth());
        const showSpinner = false;
        const scheduleCampaignReferrer = this.props.location && this.props.location.state && this.props.location.state.scheduleCampaignReferrer;
        const locationInfo = this.props.location && this.props.location.state && this.props.location.state.loc;
        this.selectedIndex = this.props && this.props.location && this.props.location.state && this.props.location.state.selectedIndex;
        this.state = {
            epicId: providerId,
            visitTypeId: visitTypeId,
            departmentId: departmentId,
            patientId: patientId,
            loginId: loginId,
            updatedVisitType: "",
            startDate: altStart ? altStart : `${dt.getFullYear()}-${dt.getMonth() + 1}-1`,
            endDate: `${dtEnd.getFullYear()}-${dtEnd.getMonth() + 1}-${dtEnd.getDate()}`,
            visit: {
                date: selectedDate,
                time: selectedTime,
                duration: 0,
                visitType: {
                    id: visitTypeId,
                    description: "",
                    idType: "",
                    startDate: null,
                    endDate: null
                },
                department: {
                    id: departmentId,
                    name: "",
                    idType: "",
                    phone: "",
                    address: {
                        street1: "",
                        street2: "",
                        city: "",
                        state: "",
                        zip: ""
                    }
                },
                reasonForVisit: "",
                patient: {
                    id: patientId ? patientId : patient ? patient.eid : "",
                    loginId: loginId ? loginId : userName,
                    name: patient ? patient.displayName : "",
                    phoneNumber: "",
                    email: email,
                    address1: "",
                    address2: "",
                    city: "",
                    state: "",
                    zip: ""
                }
            },
            createPatient: {},
            showSpinner: showSpinner,
            scheduleErrorMessage: null,
            scheduleType: this.props && this.props.location && this.props.location.state && this.props.location.state.scheduleType ? this.props.location.state.scheduleType : scheduleType,
            baseURL: "",
            visitTypeChanged: false,
            locationChanged: false,
            startingStep: 0,
            currentStep: 0,
            noSelectPatient: searchModel.noSelectPatient || (this.props && this.props.location && this.props.location.state && this.props.location.state.noSelectPatient),
            surveyDisplayed: false,
            isFromDotCOM: isFromDotCOM ? true : false,
            scheduleCampaignReferrer: scheduleCampaignReferrer,
            locationInfo:locationInfo, 
        };
        this.formattedPhoneNo = '';
        this.updatedPatientId = undefined;
        this.canShowSpinner = false;
        this.isUserActivated = false;
        this.stepProxyPatient = undefined;
        this.stepNoProxyPatient = undefined;
        this.responseModel = {};
        this.providerData = null;
        this.tokenValue = '';
        this.userSelected = this.props && this.props.location && this.props.location.state && this.props.location.state.selectedUser ? this.props.location.state.selectedUser : null;
        this.saveStepInfo = this.saveStepInfo.bind(this);
        //this.resetWizard = this.resetWizard.bind(this);
        this.requestScheduleInfo = this.requestScheduleInfo.bind(this);
        this.setScheduleDates = this.setScheduleDates.bind(this);
        this.saveSlot = this.saveSlot.bind(this);
        this.getEndDate = this.getEndDate.bind(this);
        this.getVisitTypeDisplayName = this.getVisitTypeDisplayName.bind(this);
        this.render = this.render.bind(this);
        this.initiateSearch = this.initiateSearch.bind(this);
        this.loadVisitTypeAndLocation = this.loadVisitTypeAndLocation.bind(this);
        this.loadScheduleForProvider = this.loadScheduleForProvider.bind(this);
        this.fluServiceSchedulingAppointment = this.fluServiceSchedulingAppointment.bind(this);
        this.updateAddDependentShowPreference = this.updateAddDependentShowPreference.bind(this);
        this.getProviderId = this.getProviderId.bind(this);
        this.getVisitInfoCallBack = this.getVisitInfoCallBack.bind(this);
        this.gotoEarliestDate = false;
        this.canShowFirstAvailableSlot = false;
        this.visitData = null;
        this.canShowNext = false;
        window.formChanged = false;
    }

    componentWillMount() {
        this.setState({ baseURL: window.location.pathname });
    }

    componentDidMount() {
        this.canShowFirstAvailableSlot = true;
        this.visitData = null;
        const { scheduleCampaignReferrer } = this.state;
        const scheduleCampaignActivity = scheduleCampaignReferrer ? { scheduleCampaignReferrer: scheduleCampaignReferrer } : {};
        this.initiateSearch();
        if (this.props.match.params.altStart === "") {
            this.setScheduleDates(new Date());
        }
        logUI("MBHWeb.UI.ScheduleFlu.ComponentDidMount", new Date(), Tools.getURLPath(), scheduleCampaignActivity);
        this.byPassProxy();
    }

    loadVisitTypeAndLocation(providerId, providerIdType, scheduleType) {
        providerIdType = 'EpicID';
        const searchModel = { providerId, providerIdType, scheduleType: scheduleType ? scheduleType : this.state.scheduleType };
        if (providerIdType === PROVIDER_TYPE_EPIC_ID) {
            this.epicId = providerId;
        }

        // wizard screen 0's visit type and department have been provided by route params; load the calendar...
        if (providerId && ((!this.state.epicId && providerIdType === PROVIDER_TYPE_EPIC_ID)))
            this.setState({ dontLoadSchedule: true });
        else
            this.setState({ dontLoadSchedule: false });

        logUI("MBHWeb.ScheduleFlu.Open.LoadVisitTypeAndLocation", new Date(), Tools.getURLPath(), searchModel);
        this.props.getVisitInfo(searchModel, this.getVisitInfoCallBack);
    }


    getVisitInfoCallBack(isSuccess, visitInfo) {
        this.visitData = visitInfo;
        if (isSuccess) {
            const state = this.state;
            let isNeedVisitUpdate = false;
            let isNeedDepartmentUpdate = false;
            if (state.visit.visitType.id !== "") {
                if (visitInfo && visitInfo.visitTypes) {
                    const visitTypes = visitInfo.visitTypes;
                    if (visitTypes) {
                        for (let i = 0; i < visitTypes.length; i++) {
                            const v = visitTypes[i];
                            for (let j = 0; j < v.iDs.length; j++) {
                                const id = v.iDs[j];
                                if (id.id === state.visit.visitType.id) {
                                    state.visit.visitType.idType = id.type;
                                    state.visit.visitType.description = v.displayName;
                                    isNeedVisitUpdate = true;
                                    break;
                                }
                            }
                            if (isNeedVisitUpdate) {
                                break;
                            }
                        }
                    }
                }
            }
            if (state.visit.department.id !== "" && state.visit.department.idType === '') {
                const departments = visitInfo && visitInfo.departments ? visitInfo.departments : [];
                for (let i = 0; i < departments.length; i++) {
                    const dept = departments[i];
                    for (let j = 0; j < dept.iDs.length; j++) {
                        const id = dept.iDs[j];
                        if (id.id === state.visit.department.id) {
                            state.visit.department.idType = id.type;
                            state.visit.department.address.street1 = dept.address1;
                            state.visit.department.address.street2 = dept.address2;
                            state.visit.department.address.city = dept.city;
                            state.visit.department.address.state = dept.state;
                            state.visit.department.address.zip = dept.zip;
                            state.visit.department.phone = dept.phone;
                            isNeedDepartmentUpdate = true;
                            break;
                        }
                    }
                    if (isNeedDepartmentUpdate) {
                        break;
                    }
                }
            }
            if (isNeedVisitUpdate || isNeedDepartmentUpdate) {
                this.setState(state);
            }

        }
    }

    selectedDayAvailabilty = (val) => {
        this.apptSlotNotAvailable = val;
    }

    selectedTimeAvailability = (val) => {
        this.apptTimeNotAvailable = val;
    }
    checkMonthChanged= (val) => {
        this.isMonthChanged = val;
    }

    updateAddDependentShowPreference = () => {
        const { savePreferenceCall } = this.props;
        const { isAddDependentSkipped } = this.state;
        if (isAddDependentSkipped && savePreferenceCall)
            savePreferenceCall();
    }

    initiateSearch() {
        const searchModel = this.getSearchModel();
        let {
            providerId,     // required
            providerIdType, // required
            selectedDate,   // optional YYYY-MM-DD 
        } = searchModel;
        let dt = new Date();
        if (selectedDate !== "") {
            const selDt = Tools.toJSDate(`${selectedDate} 00:00:00`, DATE_FORMAT);
            dt = new Date(selDt.getFullYear(), selDt.getMonth(), 1);
        }
        else {
            dt.setDate(1);
        }

        let newProviderId = searchModel.npi ? searchModel.npi : providerId;
        if (newProviderId) {
            this.loadVisitTypeAndLocation(newProviderId, providerIdType);
        }
    }

    // bug fix
    byPassProxy = () => {
        const { location, updateBypassProxyAndInfo } = this.props;
        const params = location.search ? queryString.parse(location.search) : {};
        const { bypassProxyAndInfo = false } = params;
        if (bypassProxyAndInfo && bypassProxyAndInfo !== 'false') {
            updateBypassProxyAndInfo(true);
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (document.getElementsByClassName("status-banner-container status-success").length > 0 && !this.state.surveyDisplayed) {
            console.info(`Schedule componentDidUpdate loading survey`);
            try {
                if (window.QSI && window.QSI.API) {
                    window.QSI.API.unload();
                    window.QSI.API.load().done(() => {
                        console.info(`Schedule componentDidUpdate QSI.API.run() SUCCESS ${document.getElementsByClassName("status-banner-container status-success").length}`);
                        window.QSI.API.run();
                    });
                    this.setState({ surveyDisplayed: true });
                }
            } catch (e) {
                console.warn(`Schedule componentDidUpdate QSI.API.run() failed`, e);
            }
        }
    }


    getSearchModel() {
        const { match, location } = this.props;
        let searchModel = match && match.params;
        if (searchModel.npi && searchModel.npi !== 'null') {
            searchModel.providerIdType = PROVIDER_TYPE_NPI;
            searchModel.providerId = searchModel.npi;
        }
        else {
            searchModel = location.search ? queryString.parse(location.search) : location.searchParms && queryString.parse(location.searchParms);
            if (!searchModel) {
                return {};
            }
            searchModel.providerIdType = PROVIDER_TYPE_EPIC_ID;
            searchModel.providerId = searchModel.epicId;
        }
        if (!searchModel.scheduleType) {
            searchModel.scheduleType = OPEN_SCHEDULE_TYPE;
        }
        searchModel.selectedDate = searchModel.date;
        searchModel.selectedTime = searchModel.time;
        return searchModel;
    }

    getEndDate(dtStart) {
        let dtEnd = new Date(dtStart);
        dtEnd.setDate(1);
        let next = dtEnd.getDate() + 30;
        dtEnd.setDate(next);
        return dtEnd;
    }

    setScheduleDates(startDt) {
        let dtStart = new Date(startDt);
        dtStart.setDate(1);
        let dtEnd = this.getEndDate(dtStart);

        this.setState({
            startDate: `${dtStart.getFullYear()}-${dtStart.getMonth() + 1}-${dtStart.getDate()}`,
            endDate: `${dtEnd.getFullYear()}-${dtEnd.getMonth() + 1}-${dtEnd.getDate()}`
        });
    }

    callbackOnLeave = () => {
        const stepManager = this.refOurStepManager.current;
        let restartAtStep = null;
        this.updateAddDependentShowPreference();
        if (window.userToSwitch) {
            this.props.switchToMyChartUser(window.userToSwitch, window.userToSwitch.index);
            this.userSelected = null;
            restartAtStep = 0;
            if (stepManager && stepManager.childCollection && stepManager.childCollection[1] && stepManager.childCollection[1].props && stepManager.childCollection[1].props.steptitle.toLowerCase() === "select doctor")
                restartAtStep = 1;
            if (restartAtStep)
                this.refOurStepManager.current.goBack(restartAtStep, true);
        }
    }

    loadScheduleForProvider() {
        let fluVisitTypeId = this.props.serverData && this.props.serverData.fluVisitTypeId;
        let cacheDate = '';
        if (this.visitData) {
            const types = this.visitData && this.visitData.visitTypes.length > 0 ? this.visitData.visitTypes : [];
            for (let i = 0; i < types.length; i++) {
                let ids = types[i].iDs;
                for (let idCount = 0; idCount < ids.length; idCount++) {
                    if (ids[idCount].id === fluVisitTypeId) {
                        cacheDate = types[i].earliestCachedSlotDate;
                    }
                }
            }
        }

        let visitDate = this.state.visit && this.state.visit.date ? Tools.toJSDate(this.state.visit.date) : "";
        //
        //let startDate = cacheDate ?  Tools.toJSDate(cacheDate) : Tools.toJSDate(this.state.startDate);
        //let startDt = isFromDotCOM && startDate ? Tools.getStartOfMonth(startDate.getFullYear(), startDate.getMonth()) :Tools.toJSDate(cacheDate);
       // let dt =  this.state.isFromDotCOM && startDt ?  Tools.toJSDate(startDt) :Tools.toJSDate(startDt)
       let startDt = visitDate && Tools.getStartOfMonth(visitDate.getFullYear(), visitDate.getMonth());  
       let dt = this.state.isFromDotCOM && startDt ? Tools.toJSDate(startDt) : Tools.toJSDate(cacheDate);
       let start = dt && Tools.dateSimpleFormat(dt);

        let dtEnd = dt && Tools.getEndOfMonth(dt.getFullYear(), dt.getMonth()); 
        let end = `${dtEnd.getFullYear()}-${dtEnd.getMonth() + 1}-${dtEnd.getDate()}`;
        //let end = this.state.endDate;
        // bugfix
        if (this.state.startDate.indexOf("NaN") >= 0) {
            let dtStart = new Date();
            dt.setDate(1);
            let dtEnd = new Date();
            dtEnd.setDate(1);
            dtEnd.setDate(dt.getDate() + 29);
            start = `${dtStart.getFullYear()}-${dtStart.getMonth() + 1}-${dtStart.getDate()}`;
            end = `${dtEnd.getFullYear()}-${dtEnd.getMonth() + 1}-${dtEnd.getDate()}`;
        }

        let searchModel = null;
        this.setState({
            //updatedVisitType : this.changedVisitTypeId.length > 0 ? this.changedVisitTypeId : this.state.visit.visitType.id,
            updatedVisitType: this.state.visit.visitType.id,
        })

        searchModel = {
            providerId: this.state.epicId,
            providerIdType: PROVIDER_TYPE_EPIC_ID,
            departmentId: this.state.visit.department.id,
            scheduleType: this.state.scheduleType,
            //visitTypeId: this.changedVisitTypeId.length > 0 ? this.changedVisitTypeId : this.state.visit.visitType.id,
            visitTypeId: this.state.visit.visitType.id,
            start: start,
            end: end,
            getEarliestSchedule: false
        };
        this.setState({ showSpinner: true });
        this.waitingOnScheduleCall = true;
        this.waitingOnEarliestScheduleCall = false;
        this.earliestScheduleApplied = false;
        this.props.getScheduleInfo(searchModel, this.onOpenScheculingCallCompleted);
    }



    requestScheduleInfo(allowStepForward, getEarliestSchedule) {

        let startDate = this.state.startDate;
        let endDate = this.state.endDate;
        const { visit } = this.state;
        let start1 = Tools.toJSDate(`${visit && visit.visitType && visit.visitType.startDate ? visit.visitType.startDate : startDate} 00:00:00`, DATE_FORMAT);
        let startDt1 = `${this.state.startDate} 00:00:00`;
        startDt1 = `${start1.getFullYear()}-${start1.getMonth() + 1}-${start1.getDate()}`;
        const visitTypeStartDate = startDt1 && Tools.toJSDate(`${startDt1} 00:00:00`, DATE_FORMAT);
        const visitTypeEndOfMonth = visitTypeStartDate && Tools.getEndOfMonth(visitTypeStartDate.getFullYear(), visitTypeStartDate.getMonth());
        const visitTypeEndDate = visitTypeEndOfMonth && `${visitTypeEndOfMonth.getFullYear()}-${visitTypeEndOfMonth.getMonth() + 1}-${visitTypeEndOfMonth.getDate()}`;
        visit.visitType.endDate = visitTypeEndDate;
        let m = null;
        m = null;
        m = null;
        m = new Object();
        m.start = startDt1;
        m.end = visit && visit.visitType && visit.visitType.endDate ? visit.visitType.endDate : endDate;
        m.providerId = this.state.epicId || this.epicId;
        m.providerIdType = PROVIDER_TYPE_EPIC_ID;
        m.scheduleType = this.state.scheduleType;
        //m.visitTypeId = this.changedVisitTypeId.length > 0 ? this.changedVisitTypeId : this.state.visit.visitType.id;
        m.visitTypeId = this.state.visit.visitType.id;
        m.departmentId = this.state.visit.department.id;
        m.allowStepForward = allowStepForward === undefined ? false : allowStepForward;
        //m.allowStepForward = allowStepForward;
        m.getEarliestSchedule = getEarliestSchedule === undefined ? false : getEarliestSchedule;
        //m.getEarliestSchedule = getEarliestSchedule
        this.waitingOnScheduleCall = true;
        this.waitingOnEarliestScheduleCall = getEarliestSchedule;
        this.earliestScheduleApplied = false;
        if (!this.state.dontLoadSchedule)
            this.setState({ showSpinner: true });
        this.props.getScheduleInfo(m, this.onOpenScheculingCallCompleted);
    }

    onOpenScheculingCallCompleted = (scheduleDays, error, value, provider) => {
        const enableFluVaccineSchedulingWorkflow = this.props.serverData && this.props.serverData.enableFluVaccineSchedulingWorkflow ;
        if (this.state.isFromDotCOM && enableFluVaccineSchedulingWorkflow) {
            const apptInfoStepValue = this.getIndexByStepTitle("Appointment Info");
            const patientInfoStepValue = this.getIndexByStepTitle("Patient Info");
            if (!this.state.isFromVideoVisitOptions && this.refOurStepManager && this.refOurStepManager.current && apptInfoStepValue !== -1) {
                 if(enableFluVaccineSchedulingWorkflow && !this.apptSlotNotAvailable && !this.props.getScheduleError &&  patientInfoStepValue !== -1 && !this.apptTimeNotAvailable && !this.props.hasMyChart && !this.isMonthChanged) {
                    this.refOurStepManager.current.goToNewStep(true,patientInfoStepValue);
                }
            }
        }

        this.waitingOnScheduleCall = false;
        this.providerData = provider;
        if (this.gotoEarliestDate && this.earliestScheduleApplied) {
            return;
        }
        const state = this.getUpdatedState(scheduleDays);
        if (!this.waitingOnEarliestScheduleCall && !this.waitingOnScheduleCall2) {
            state.showSpinner = false;
        }
        this.setState(state);
    }

    getUpdatedState(scheduleDays) {
        const state = this.state;
        if (!state.visit.date && scheduleDays && scheduleDays.length) {
            state.visit.date = scheduleDays[0].date;
        }
        if (this.props.visitTypeAndLocation && this.props.visitTypeAndLocation.departments) {
            const departments = this.props.visitTypeAndLocation.departments;
            for (let i = 0; i < departments.length; i++) {
                const dept = departments[i];
                for (let j = 0; j < dept.iDs.length; j++) {
                    const id = dept.iDs[j];
                    if (id.id === this.state.visit.department.id) {
                        state.visit.department.idType = id.type;
                        state.visit.department.address.street1 = dept.address1;
                        state.visit.department.address.street2 = dept.address2;
                        state.visit.department.address.city = dept.city;
                        state.visit.department.address.state = dept.state;
                        state.visit.department.address.zip = dept.zip;
                        state.visit.department.phone = dept.phone;
                    }
                }
            }
        }

        if (state.visit.visitType.id !== "" && state.visit.visitType.idType === "") {
            if (this.props.providerSchedule && this.props.providerSchedule.visitTypes) {
                const visitTypes = this.props.providerSchedule.visitTypes;
                if (visitTypes) {
                    for (let i = 0; i < visitTypes.length; i++) {
                        const v = visitTypes[i];
                        for (let j = 0; j < v.iDs.length; j++) {
                            const id = v.iDs[j];
                            if (id.id === this.state.visit.visitType.id) {
                                state.visit.visitType.idType = id.type;
                                state.visit.visitType.description = v.displayName;
                            }
                        }
                    }
                }
            }
        }

        return state;
    }

    saveStepInfo(info, loadSchedule, gotoEarliestDate, allowStepForward) {
        this.gotoEarliestDate = gotoEarliestDate;
        window.formChanged = true;
        this.setState({ ...info }, () => {
            const { dontLoadSchedule } = this.state;
            // request schedule info for the calendar once we've got the ids...
            if (loadSchedule === true && !dontLoadSchedule) {
                logUI("MBHWeb.ScheduleFlu.Open.RequestScheduleInfo", new Date(), Tools.getURLPath(), info);
                this.requestScheduleInfo(allowStepForward, gotoEarliestDate);
            }

            // post schedule once we've got the ids and the reason...
            if (this.state.visit.visitType.id !== "" && this.state.visit.department.id !== "" && this.state.visit.date !== "" && this.state.visit.time !== "" && this.state.visit.reasonForVisit !== "") {
                logUI("MBHWeb.ScheduleFlu.Appointment", new Date(), Tools.getURLPath(), info);

            }
        });
    }

    tryAgain = (startingStep) => {
        this.setState({
            scheduleCompleted: false,
            startingStep: typeof startingStep !== 'undefined' ? startingStep : this.state.startingStep,
            isAddDependentSkipped: false,
            currentStep: startingStep,
        }, () => this.refOurStepManager.current.refresh());
    }

    createPatient(userInfo) {
        const patientModel = {
            email: userInfo.email,
            firstName: userInfo.firstName,
            lastName: userInfo.lastName,
            dateOfBirth: userInfo.dateOfBirth,
            gender: userInfo.gender,
            nationalIdentifier: userInfo.nationalIdentifier,
            departmentId: this.state.visit.department.id,
            departmentIdType: this.state.visit.department.idType
        };

        if (userInfo.patientPhone !== "") {
            patientModel.phoneNumbers = [{ number: userInfo.patientPhone, type: "Home Phone" }];
        }

        if (userInfo.mailingAddress && userInfo.mailingAddress.streetNumber !== "") {
            patientModel.houseNumber = userInfo.mailingAddress.streetNumber;
            patientModel.streetLine1 = userInfo.mailingAddress.streetNumber + " " + userInfo.mailingAddress.street;
            patientModel.city = userInfo.mailingAddress.city;
            patientModel.state = userInfo.mailingAddress.state;
            patientModel.zipCode = userInfo.mailingAddress.zip;
        }

        this.props.createPatient(patientModel, this.props.userToken);

        // insurance is added when creating a patient, but needed by ScheduleAppointment...
        if (userInfo.insuranceName !== "") {
            this.setState({
                insurance: {
                    insuranceName: userInfo.insurance.insuranceName,
                    memberNumber: userInfo.insurance.memberId,
                    groupNumber: userInfo.insurance.groupNumber,
                    subscriberId: userInfo.insurance.subscriberId
                }
            });
        }
    }

    getProviderId() {
        let schedule = this.props.providerSchedule; 
        const selDate = schedule && schedule.scheduleDays && schedule.scheduleDays.filter(slot => Tools.isSameDate(slot.date, this.state.visit.date));
        let providerValue = [];
        if (selDate && selDate.length > 0) {
            const selTime = selDate[0].slots.filter(time => time.time === this.state.visit.time);
            if (selTime && selTime.length > 0) {
                for (let item of selTime) {
                    if (item.provider && item.provider.length) {
                        item.provider.map(obj => providerValue.push(obj.id));
                    }
                }
                return providerValue.toString();
            }
        }
        else {
            return this.state.epicId
        }
    }

    fluServiceSchedulingAppointment() {
        this.canShowSpinner = true;
        const token = this.props.userToken;
        const { createPatient } = this.state;
        let visit = this.state.visit;
        let dateValue = Tools.toJSDate(`${visit.date} 00:00:00`, DATE_FORMAT);
        let dt = Tools.dateSimpleFormat(dateValue);
        let id = this.props.currentUser ? this.props.currentUser.externalId : "";
        let idType = "External";
        let patientModel = {};
        if (createPatient && Object.keys(createPatient).length > 0) {
            patientModel = {
                firstName: this.props.userDetails.Givenname,
                lastName: this.props.userDetails.Surname,
                email: createPatient.email ? createPatient.email : this.props.userDetails.Email,
                dateOfBirth: createPatient.dateOfBirth ? createPatient.dateOfBirth : "",
                gender: createPatient.gender ? createPatient.gender : "",
                nationalIdentifier: createPatient.nationalIdentifier ? createPatient.nationalIdentifier : "",
                departmentId: visit.department.id,
                departmentIdType: visit.department.idType
            };
            if (createPatient.phoneNumbers && createPatient.phoneNumbers.length > 0) {
                patientModel.phoneNumbers = this.state.createPatient.phoneNumbers;
            }
            if (createPatient.houseNumber) {
                patientModel.houseNumber = createPatient.houseNumber;
                patientModel.streetLine1 = createPatient.streetLine1;
                patientModel.city = createPatient.city;
                patientModel.state = createPatient.state;
                patientModel.zipCode = createPatient.zipCode;
            }
        }

        let scheduleModel = null;
        scheduleModel = {
            scheduleType: this.state.scheduleType,
            loginId: this.props.patientLoginId,
            myChartId: "",
            proxyPatientId: id,
            proxyPatientIdType: idType,
            // visitTypeId: this.changedVisitTypeId && this.changedVisitTypeId,
            visitTypeId: this.state.visit.visitType.id,
            //visitTypeIdType: this.changedVisitTypeIdType && this.changedVisitTypeIdType,
            visitTypeIdType: this.state.visit.visitType.idType,
            providerId: this.getProviderId(),
            providerIdType: this.state.scheduleType != OPEN_SCHEDULE_TYPE ? PROVIDER_NPI : PROV_ID,
            departmentId: `${visit.department.id}`,
            departmentIdType: visit.department.idType,
            date: dt,
            time: visit.time,
            comments: "Flu Vaccine"
        };

        const insurance = createPatient.insurance;
        if (insurance && insurance.insuranceName !== "") {
            scheduleModel.insurance = {
                insuranceName: insurance.insuranceName,
                memberNumber: insurance.memberNumber,
                groupNumber: insurance.groupNumber,
                subscriberId: insurance.subscriberId
            };
        }
        this.updatedVisitType = scheduleModel;
        if (this.props.currentUser && this.props.hasMyChart) {
            logUI("MBHWeb.UI.ScheduleFlu.scheduleAppointment", new Date(), Tools.getURLPath(), scheduleModel);
            // schedule appointment for existing patient...
            this.props.scheduleAppointment(scheduleModel, token, this.scheduleCallCompleted);
        }
        else {
            logUI("MBHWeb.UI.ScheduleFlu.CreatePatientAndScheduleAppt", new Date(), Tools.getURLPath());
            // create patient and schedule appointment...
            this.props.createAndSchedule(patientModel, scheduleModel, token, this.scheduleCallCompleted);
        }

        //Load step at top of page
        if (typeof window !== 'undefined') {
            window.scrollTo(0, 0);
        }

        this.updateAddDependentShowPreference();

    }

    scheduleCallCompleted = (bSuccessful, sErrorMessage) => {
        let { scheduleErrorMessage } = this.state;
        if (bSuccessful) {
            if (scheduleErrorMessage !== "") {
                scheduleErrorMessage = "";
            }
        }
        else {
            if (scheduleErrorMessage !== sErrorMessage) {
                scheduleErrorMessage = sErrorMessage;
            }
        }
        this.setState({ scheduleCompleted: true, scheduleErrorMessage });
    }

    saveSlot(time, duration) {
        let visit = this.state.visit;
        visit.time = time;
        visit.duration = duration;
        this.saveStepInfo({ visit: visit });
    }
    getIndexByStepTitle(title) {
        let index = -1;
        if (this.refOurStepManager && this.refOurStepManager.current && this.refOurStepManager.current.childCollection) {
            const stepManager = this.refOurStepManager.current.childCollection;
            for (let i = 0; i < stepManager.length; i++) {
                let stepTitle = stepManager[i].props.steptitle;
                if (stepTitle && title && stepTitle.toLowerCase() === title.toLowerCase()) {
                    index = i;
                    break;
                }
            }
        }
        return index;
    }

    onUserSwitched = (userSelected, index) => {
        this.userSelected = userSelected;
        this.props.switchToMyChartUser(userSelected, index);
        this.loadScheduleForProvider();
    }

    onFemalePatientSelected = (patientSelected) => {
        this.setState({ isFemalePatientSelected: patientSelected });
    }

    onUserSelect = (userSelected) => {
        const { locationInfo } = this.state;
        this.userSelected = userSelected;
        const enableFluVaccineSchedulingWorkflow = this.props.serverData && this.props.serverData.enableFluVaccineSchedulingWorkflow;
        if (enableFluVaccineSchedulingWorkflow) {
            const eventType = "checkout";
            const list = "Find Care Page";
            const category = "Open Scheduling";
            const brand = "Flu Vaccine";
            const variant = "service flow";
            const step = 0;
            const patientStatus = 'Existing Patient';
            gaCheckout(eventType, this.props.providerId, locationInfo.locationName, locationInfo.locationID, this.selectedIndex, list, category, brand, variant, step, patientStatus);
        }
  
    }

    selectPatientMarkup = (hasProxyUsers, noSelectPatient, myProxies, hasMyChart, currentUser, isAdult, serverData, t) => {
        const apptInfoStepValue = this.getIndexByStepTitle("Appointment Info");
        const verifyScheduleStepValue = this.getIndexByStepTitle("Verify & Schedule");

        if (hasProxyUsers && !noSelectPatient) {
            this.stepProxyPatient = true;
            return (<SelectPatient
                steptitle={translateText(t, "Select Patient", t)}
                myProxies={myProxies}
                hasMychart={hasMyChart}
                currentUser={currentUser}
                switchToMyChartUser={this.onUserSwitched}
                isAdult={isAdult}
                userSelected={this.state.userSelected}
                onUserSelected={this.onUserSelect}
                shouldHideContinueButton
                activityCode="MBHWeb.UI.ScheduleFlu.AddDependent.Clicked"
                message={translateText(t, "I'm scheduling an appointment for", t) + "..."}
                iconLeftClass={"svg-schedule-color"}
                serverData={serverData}
                location={this.props.location}
                newUserSelected={this.isSwitchToNewUser}
                enableFluVaccineSchedulingWorkflow={enableFluVaccineSchedulingWorkflow}
                apptInfoStepValue={apptInfoStepValue !== -1 ? apptInfoStepValue : 0}
                verifyScheduleStepValue={verifyScheduleStepValue !== -1 ? verifyScheduleStepValue : 0}
                isFromDotCOM={this.state.isFromDotCOM}
                apptSlotNotAvailable={this.apptSlotNotAvailable}
                apptTimeNotAvailable={this.apptTimeNotAvailable}
                translate={true}
                t={t}
            />);
        }
        else if (!hasProxyUsers && !noSelectPatient && hasMyChart && isAdult) {
            this.stepNoProxyPatient = true;
            return (<NoProxy
                steptitle="Select Patient"
                shouldHideContinueButton
                removeActive
                message={translateText(t, "I'm scheduling an appointment for", t) + "..."}
                myProxies={myProxies}
                currentUser={currentUser}
                switchToMyChartUser={this.onUserSwitched}
                stepHeading={translateText(t, "Did you know?", t)}
                titleInfo={translateText(t, "You can schedule an appointment for a dependent.", t)}
                iconLeftClass={"svg-schedule-color"}
                iconRightClass={"svg-dependent"}
                onSkipProxy={this.onSkipProxy}
                activityCode="MBHWeb.UI.ScheduleFlu.NoProxy.AddDependent.Clicked"
                location={this.props.location}
                newUserSelected={this.isSwitchToNewUser}
                enableFluVaccineSchedulingWorkflow={enableFluVaccineSchedulingWorkflow}
                apptInfoStepValue={apptInfoStepValue !== -1 ? apptInfoStepValue : 0}
                verifyScheduleStepValue={verifyScheduleStepValue !== -1 ? verifyScheduleStepValue : 0}
                isFromDotCOM={this.state.isFromDotCOM}
                apptSlotNotAvailable={this.apptSlotNotAvailable}
                apptTimeNotAvailable={this.apptTimeNotAvailable}
                t={t}
                translate={true}
            />);
        }
    }

    onStepChange = (success, step) => {
        // Bug 31808: Mobile scheduling: Load step at top of page
        // Load step at top of page
        if (typeof window !== 'undefined' && success) {
            window.scrollTo(0, 0);
        }
        if (success) {
            this.setState({ currentStep: step });
        }
    }

    getVisitTypeDisplayName(visitTypes) {
        let fluVisitTypeId = this.props.serverData && this.props.serverData.fluVisitTypeId;
        for (let count = 0; count < visitTypes.length; count++) {
            if (visitTypes[count].iDs && visitTypes[count].iDs.length) {
                let ids = visitTypes[count].iDs;
                for (let idCount = 0; idCount < ids.length; idCount++) {
                    if (ids[idCount].id === fluVisitTypeId) {
                        return [visitTypes[count].displayName, visitTypes[count].name];
                    }
                }
            }
        }
        return [];
    }

    getCurrentStepTitleName = () => {
        let stepTitle = '';
        const { currentStep } = this.state;
        if (this.refOurStepManager && this.refOurStepManager.current && this.refOurStepManager.current.childCollection) {
            const stepManager = this.refOurStepManager.current;
            stepTitle = stepManager.childCollection[currentStep] && stepManager.childCollection[currentStep].props && stepManager.childCollection[currentStep].props.steptitle ?
                stepManager.childCollection[currentStep].props.steptitle : '';
        }

        return stepTitle;
    }

    checkVisitType = (data) => {
        this.setState({
            updatedVisitType: data
        });
    }

    showButton = (data) => {
        this.canShowNext = data;
    }

    isSwitchToNewUser = (data) => {
        this.isUserActivated = data;
    }

    savePatientInfo = (patient) => {
        this.setState({ createPatient: patient });
    }

    goToHome = () => {
        this.props.history.push({
            pathname: '/'
        });
    } 
    render() {
        let visitTypes = [];
        let departments = [];
        let schedule = [];
        let provider = null;
        let visitTypelabel = "";
        let visitTypeDisplayName = [];
        let selectedSlotAvailable = true;
        const {
            searchRunning, visitTypeAndLocationFailed, visitTypeAndLocation, currentUser, createPatientSuccess, createPatientFailed, hasMyChart, myProxies, serverData, getScheduleError, earliestScheduleError, t,
            match, primaryUser, age, arrivalTimeSchedule, providerSchedule, scheduleAppointmentFailed, scheduleAppointmentSuccess, screenBreakPoint, scheduleAppointmentPending, providerScheduleSuccessStatus, showDependentProxyForm, visitTypeAndLocationPending, proxyListFailure, proxyListLoaded
        } = this.props;
        const { startingStep, visit, visitTypeChanged, locationChanged, startDate, scheduleErrorMessage, baseURL, createPatient, showSpinner, scheduleCompleted, currentStep, noSelectPatient, isFromVideoVisitOptions, isFromVideoVisitDirectSchedule, isFromDotCOM, scheduleCampaignReferrer, isFemalePatientSelected,  locationInfo} = this.state;
        const isAdult = age && age > 17 ? true : false;
        const needPatientInfo = typeof currentUser === "undefined" || currentUser === null || !hasMyChart;

        if (this.state.visit && this.state.visit.department && this.state.visit.department.phone) {
            this.formattedPhoneNo = this.state.visit.department.phone.replaceAll('-', '.');
        }
        if (visitTypeAndLocation) {
            if (this.canShowFirstAvailableSlot && this.visitData !== null) {
                const isYourDoctorScheduleType = this.props.location && this.props.location.state && this.props.location.state.scheduleType;
                const { epicId, visit } = this.state;
                if (((epicId && epicId !== "")) && visit.visitType.id !== "" && visit.department.id !== "") {
                    if (!isYourDoctorScheduleType) {
                        this.setState({ showSpinner: true });
                        if (this.props.searchRunning === false) {
                            this.loadScheduleForProvider();
                            this.canShowFirstAvailableSlot = false;
                            //this.visitData = null;
                        }
                    }
                }
            }
            departments = departments ? visitTypeAndLocation.departments.map((d, i) => { return { label: d.name, label2: d.displayName, value: `${d.iDs[0].id}|${d.iDs[0].type}`, address1: d.address1, address2: d.address2, city: d.city, state: d.state, zip: d.zip, phone: d.phone }; }) : [];
            visitTypeDisplayName = visitTypeAndLocation.visitTypes && visitTypeAndLocation.visitTypes.length && this.getVisitTypeDisplayName(visitTypeAndLocation.visitTypes);
            visitTypelabel = visitTypeDisplayName && visitTypeDisplayName.length > 1 ? visitTypeDisplayName[1] : "";
        }

        if (providerSchedule) {
            visitTypes = this.providerData?.visitTypes ? this.providerData?.visitTypes.map((v, i) => { return { label: v.displayName, startDate: v.earliestCachedSlotDate, value: `${v.iDs[0].id}|${v.iDs[0].type}` }; }) : [];
            //departments = departments ? providerSchedule.departments.map((d, i) => { return { label: d.name, label2: d.displayName, value: `${d.iDs[0].id}|${d.iDs[0].type}`, address1: d.address1, address2: d.address2, city: d.city, state: d.state, zip: d.zip, phone: d.phone }; }) : []
            schedule = providerSchedule;
            provider = providerSchedule.provider;
            // make sure the date/time passed in via route params is actually available...
            if (schedule && schedule.scheduleDays && this.state.visit.date !== "" && this.state.visit.time !== "") {
                const selDate = schedule.scheduleDays.filter(slot => slot.date === this.state.visit.date);
                if (selDate && selDate.length > 0) {
                    const selTime = selDate[0].slots.filter(time => time.time === this.state.visit.time);
                    if (!selTime) {
                        selectedSlotAvailable = false;
                    }
                }
                else {
                    selectedSlotAvailable = false;
                }
            }
        }

        let insurance = [];
        if (this.props.providerDetails && this.props.providerDetails.length > 0) {
            for (var i = 0; i < this.props.providerDetails[0].insuranceV2.length; i++) {
                const ins = this.props.providerDetails[0].insuranceV2[i];
                const found = insurance.some((item) => item.label === ins.companyName);
                if (!found) {
                    insurance.push({ label: ins.companyName, value: ins.companyName });
                }
            }
        }

        const providerDetails = this.props.providerDetails && this.props.providerDetails.length > 0 ? this.props.providerDetails[0] : null;
        const hasMajorFailure = scheduleCompleted && scheduleErrorMessage;
        const hasProxyUsers = serverData && serverData.scheduleAppointmentForProxy && hasMyChart && myProxies && myProxies.length > 1;
        const currentStepTitleName = this.getCurrentStepTitleName();
        const appointmentInfoWaiting = this.props.getSchedulePending || this.props.earliestScheduleWaiting || showSpinner;
        const apptInfoStepValue = this.getIndexByStepTitle("Appointment Info");
        if (scheduleCompleted) {
            this.canShowSpinner = false;
        }

        const isMobile = !(screenBreakPoint === msgs.XL_DESKTOP || screenBreakPoint === msgs.XXL_DESKTOP) ? true : false
        const isTablet = ([msgs.MD_TABLET, msgs.LG_TABLET]).indexOf(screenBreakPoint) > -1 ? true : false; 
        return (
            <div className={"container-fluid body-content open-schedule-container service-schedule-container"}>
                <div className="row">
                    <div className="col-12">
                        {
                            !scheduleCompleted ?
                                <div className="row open-schedule__steps">
                                    <div className={this.props.mammogramQuestionsError ? "" : "col-12 progtrckr-divider"} />
                                    <div className="col-12 maxWidth-content">
                                        <div className="step-progress">

                                            <OurStepManager ref={this.refOurStepManager} baseURL={baseURL} preventEnterSubmission canSkipPage={this.skip} startingStep={startingStep} onStepChange={this.onStepChange}
                                                majorFailure={hasMajorFailure} disableNextButton={(this.state.visit.date === "" || this.state.visit.time === "")}
                                                nextButtonCls={(currentStep === apptInfoStepValue) ? "btn float-right mammogram-next-btn" : "btn"} responseModel={this.responseModel} tokenValue={this.tokenValue} translate={true} t={t}
                                            >
                                                {this.selectPatientMarkup(hasProxyUsers, noSelectPatient, myProxies, hasMyChart, currentUser, isAdult, serverData, t)
                                                }

                                                <AppointmentInfo steptitle="Appointment Info" isFromVideoVisitOptions={isFromVideoVisitOptions} searchRunning={searchRunning} waiting={appointmentInfoWaiting}
                                                    provider={provider} canShowFirstAvailableSlot={this.canShowFirstAvailableSlot} providerData={this.providerData} providerDetails={providerDetails} providerSearchModel={this.props.providerSearchModel} departments={departments} schedule={schedule}
                                                    visit={visit} visitTypes={visitTypes} visitTypeAndLocationFailed={visitTypeAndLocationFailed} visitTypeChanged={visitTypeChanged} locationChanged={locationChanged}
                                                    routeDate={match.params.date} routeTime={match.params.time} saveSlot={this.saveSlot} saveStepInfo={this.saveStepInfo}
                                                    startDate={startDate} providerScheduleSuccessStatus={providerScheduleSuccessStatus} getScheduleError={this.props.getScheduleError}
                                                    showErrors={searchRunning === false && showSpinner === false} routeStepNumber={match.params.step ? match.params.step : 5} isFromDotCOM={isFromDotCOM}
                                                    earliestScheduleError={this.props.earliestScheduleError} serverData={serverData} visitTypeSelectedValue={isFromVideoVisitDirectSchedule}
                                                    enableFluVaccineSchedulingWorkflow={enableFluVaccineSchedulingWorkflow} history={this.props.history} hasMyChart={hasMyChart} match={match} selectedDayUnavailable={this.selectedDayAvailabilty} selectedTimeUnavailable={this.selectedTimeAvailability} isMonthChanged={this.checkMonthChanged} changedVisitTypeId={this.changedVisitTypeId} visitTypeCallback={this.checkVisitType} isDisableSelectVisitAndDepartOption={false} visitTypeDisplayName={visitTypeDisplayName}
                                                    locationInfo={locationInfo} selectedIndex={this.selectedIndex} translate={true} t={t}
                                                />

                                                {needPatientInfo &&
                                                    <PatientInfo steptitle="Patient Info" model={createPatient} savePatientInfo={this.savePatientInfo} providerDetails={providerDetails} t={t} translate={true}
                                                        insurancePlans={insurance} onFemalePatientSelected={this.onFemalePatientSelected} createPatientSuccess={createPatientSuccess} createPatientFailed={createPatientFailed} userHasEmail={this.props.patientEmail}
                                                    />
                                                }
                                                {
                                                    <ServiceVerifyNSchedule steptitle="Verify & Schedule"
                                                        visit={visit} visitTypelabel={visitTypelabel} enableFluVaccineSchedulingWorkflow={enableFluVaccineSchedulingWorkflow} apptInfoStepValue={apptInfoStepValue !== -1 ? apptInfoStepValue : 0} departments={departments} onSubmit={this.fluServiceSchedulingAppointment} currentUser={currentUser} primaryUser={primaryUser} shouldHideContinueButton
                                                        scheduleAppointmentForProxy={serverData && serverData.scheduleAppointmentForProxy}
                                                        locationInfo={locationInfo} selectedIndex={this.selectedIndex} t={t} translate={true}
                                                    />
                                                }


                                            </OurStepManager>

                                        </div>
                                    </div>
                                </div>
                                :
                                <OpenScheduleConfirmationSuccess
                                    visit={visit}
                                    provider={provider}
                                    providerDetails={providerDetails}
                                    serverData={serverData}
                                    visitTypelabel={visitTypelabel}
                                    primaryUser={primaryUser}
                                    currentUser={currentUser}
                                    scheduleAppointmentForProxy={serverData && serverData.scheduleAppointmentForProxy}
                                    nonMyChartPatientDetails={createPatient}
                                    schedule={schedule}
                                    scheduleAppointmentFailed={scheduleAppointmentFailed}
                                    departments={departments}
                                    createPatientFailed={createPatientFailed}
                                    tryAgain={this.tryAgain}
                                    scheduleAppointmentSuccess={scheduleAppointmentSuccess}
                                    arrivalTimeSchedule={arrivalTimeSchedule}
                                    scheduleCampaignReferrer={scheduleCampaignReferrer}
                                    enableFluVaccineSchedulingWorkflow={enableFluVaccineSchedulingWorkflow}
                                    isMobile={isMobile}
                                    isTablet={isTablet}
                                    t={t}
                                    translate={true}
                                    sendBack={this.showButton}
                                />
                        }
                    </div>
                </div>
                {!scheduleCompleted && currentStep > 0 &&
                    <ConfirmationModal when={!scheduleAppointmentSuccess || !scheduleAppointmentFailed} noReload blockNavigation={this.blockNavigation} callbackOnLeave={this.callbackOnLeave} switchToMyChartUser={this.onUserSwitched}
                        message={translateText(true, "Would you like to continue without saving?", t)}
                        actionText1={translateText(true, "STAY ON THIS PAGE", t)}
                        actionText2={translateText(true, "CONTINUE WITHOUT SAVING", t)}
                    />
                }

                {((!visitTypeAndLocationFailed && !getScheduleError && !earliestScheduleError && (showSpinner || searchRunning === true || scheduleAppointmentPending === true)) || (this.canShowFirstAvailableSlot) || (this.canShowSpinner)) &&
                    <Spinner />
                }
                {!proxyListFailure && !proxyListLoaded && <Spinner />}
                {(currentStepTitleName && (currentStepTitleName.toLowerCase() === 'visit type' || (isFromDotCOM && currentStepTitleName.toLowerCase() === 'appointment info')) && visitTypeAndLocationPending && !visitTypeAndLocationFailed) && <Spinner />}
            </div>

        )
    }

};

const mapStateToProps = (state, ownProps) => {
    const pl = [];
    if (state.domain.pl) {
        state.domain.pl.forEach((proxy) => {
            pl.push(d.hydrateProxyUser(proxy));
        });
    }
    const primaryUserDomain = d ? d.hydrateProxyUser(state.domain.pu) : {};
    const primaryUserSSO = state.sso.primaryUser;
    let primaryUser = primaryUserDomain || primaryUserSSO;
    let cur = d ? d.hydrateProxyUser(state.domain.cu) : {};

    if (state.openScheduling.createdPatient) {
        const created = state.openScheduling.createdPatient;
        cur = {
            displayName: created.name,
            externalId: created.ids && created.ids.length > 0 ? created.ids.find((v, i) => { return v.type && v.type.toLowerCase() === "external" }).id : ""
        };
    }

    return {
        visitTypeAndLocation: state.openScheduling.visitTypeAndLocation,
        //mammogramQuestionsError: state.openScheduling.mammogramQuestionsError,
        visitTypeAndLocationFailed: state.openScheduling.visitTypeAndLocationFailed,
        visitTypeAndLocationPending: state.openScheduling.visitTypeAndLocationPending,
        providerSchedule: state.openScheduling.providerSchedule,
        providerScheduleSuccessStatus: (!state.openScheduling.providerSchedule || (state.openScheduling.success && !state.openScheduling.error)) ? true : false,
        getScheduleError: state.openScheduling.getScheduleError,
        searchRunning: state.openScheduling.searchRunning,
        scheduleAppointmentSuccess: state.openScheduling.scheduleAppointmentSuccess,
        scheduleAppointmentFailed: state.openScheduling.scheduleAppointmentFailed,
        scheduleAppointmentPending: state.openScheduling.scheduleAppointmentPending,
        createPatientSuccess: state.openScheduling.createPatientSuccess,
        createPatientFailed: state.openScheduling.createPatientFailed,
        proxyListFailure: state.memberships.proxyListFailure,
        proxyListLoaded: state.memberships.proxyListLoaded,
        primaryUser: primaryUser,
        currentUser: cur,
        serverData: state.session.serverData,
        hasMyChart: state.domain.hm,
        patientEmail: state.domain.e,
        patientLoginId: state.domain.un,
        userToken: state.domain.t,
        userDetails: state.sso.userDetails,
        providerSearchModel: state.providers.searchModel,
        getSchedulePending: state.openScheduling.getSchedulePending,
        providerDetails: state.providers.providerDetails,
        earliestScheduleWaiting: state.openScheduling.earliestScheduleWaiting,
        earliestScheduleError: state.openScheduling.earliestScheduleError,
        externalID: state.domain.cu ? state.domain.cu.ei : null,
        myProxies: pl,
        age: state.domain.age,
        showDependentProxyForm: state.session.showDependentProxyForm,
        history: state.session.history,
        arrivalTimeSchedule: state.openScheduling.arrivalTimeSchedule,
        scheduleAppointmentData: state.openScheduling.schedule,
        screenBreakPoint: state.common.screenBreakPoint,
        ...ownProps
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getVisitInfo: (searchModel, getVisitInfoCallBack) => {
            dispatch({
                type: types.OPEN_SCHEDULE_VISIT_TYPE_LOCATION,
                searchModel: searchModel,
                callback: getVisitInfoCallBack
            });
        },
        getScheduleInfo: (searchModel, callback, callbackOfEarliesSchedule) => {
            dispatch({ type: types.OPEN_SCHEDULE_PROVIDER, searchModel, callback, callbackOfEarliesSchedule, isMammogramSchedule: true });
        },
        getEarliestSchedule: (searchModel, callback) => {
            dispatch({ type: types.OPEN_SCHEDULE_EARLIEST, searchModel, callback });
        },
        createPatient: (model, token) => {
            dispatch({
                type: types.OPEN_SCHEDULE_CREATE_PATIENT,
                model: model,
                token: token
            });
        },
        scheduleAppointment: (model, token, scheduleCallBack) => {
            dispatch({
                type: types.OPEN_SCHEDULE_SCHEDULE,
                model: model,
                token: token,
                callBack: scheduleCallBack,
                isMammogramSchedule: true,
                translate: true
            });
        },
        createAndSchedule: (patientModel, scheduleModel, token, scheduleCallBack) => {
            dispatch({
                type: types.OPEN_SCHEDULE_CREATE_AND_SCHEDULE,
                patient: patientModel,
                schedule: scheduleModel,
                token: token,
                callBack: scheduleCallBack,
                isMammogramSchedule: true,
                translate: true
            });

        },
        clearReduxState: () => {
            dispatch({ type: types.OPEN_SCHEDULE_CLEAR_REDUX_STATE });
        },
        getProviderDetail: (searchModel) => {
            dispatch({ type: types.PROVIDER_DETAIL, searchModel: searchModel });
        },
        switchToMyChartUser: (user, index) => {
            dispatch({ type: types.SWITCH_USER_SAGA, user, index });
            dispatch({ type: types.SWITCH_TO_PHARMACY_USER, pharmacyUser: null });
        },
        savePreferenceCall: () => {
            dispatch({
                type: types.UPDATE_ADD_DEPENDENT_PROXY_PREFERENCE
            });
        },
        updateBypassProxyAndInfo: payload => dispatch({ type: types.UPDATE_BYPASS_PROXY_AND_INFO, payload }),
        //saveMammogramQuestionsResponse: (ResponseSearchModel, token) => dispatch({ type: types.OPEN_SCHEDULE_QUESTIONS_RESPONSE, searchModel: ResponseSearchModel, token }),
        // getMammogramQuestions: (QuestionsSearchModel) => {
        //     dispatch({ type: types.OPEN_SCHEDULE_MAMMOGRAM_QUESTIONS, searchModel: QuestionsSearchModel });
        // }

    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ScheduleFlu)));